/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { AnyAction } from 'redux';
import { Log } from '../../../core/logging/Log';

import {
    showVideoDebugOverlayAction,
    hideVideoDebugOverlayAction,
} from './videodebugoverlay.actions';

import { SHOW_VIDEO_DEBUG_OVERLAY, HIDE_VIDEO_DEBUG_OVERLAY } from './videodebugoverlay.types';

const initialState: {
    isVideoDebugOverlayActive: boolean;
} = {
    isVideoDebugOverlayActive: false,
};

const TAG = 'videodebugoverlay';

const videoDebugOverlay = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SHOW_VIDEO_DEBUG_OVERLAY:
        case HIDE_VIDEO_DEBUG_OVERLAY:
            return {
                ...state,
                isVideoDebugOverlayActive: payload.isVideoDebugOverlayActive,
            };
        default:
            return state;
    }
};
export const showVideoDebugOverlay = () => (dispatch: Function) => {
    Diagnostics.info(TAG, 'showVideoDebugOverlay');
    Log.i(TAG, 'showVideoDebugOverlay');
    dispatch(showVideoDebugOverlayAction());
};

export const hideVideoDebugOverlay = () => (dispatch: Function) => {
    Diagnostics.info(TAG, 'hideVideoDebugOverlay');
    Log.i(TAG, 'hideVideoDebugOverlay');
    dispatch(hideVideoDebugOverlayAction());
};

export default videoDebugOverlay;
